<template>
  <div class="row-details d-md-flex flex-row" :class="containerMargin">
    <slot>
      <div v-if="label" class="text-primary mr-3" :class="labelClass">{{label}}:</div>
    </slot>
    <div class="align-items-center contact-detail-value">{{value}}</div>
  </div>
</template>

<script>
export default {
  name: 'DetailRow',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    containerMargin: {
      type: String,
      default: 'mb-2',
    },
    value: {},
  },
};
</script>
